let myChart;
export default (ID, chartContainer, data) => {
    return new Promise((resolve, reject) => {
        console.log("init HibLawStateNew");
        //法遵上課區間
        const d = new Date() //時間
        //var dom = document.getElementById(ID);

        //let dom = document.querySelector(ID + " .chartContainer")
        let dom = chartContainer
        dom.innerHTML ="123"
        //let tContainer = document.querySelector(ID + " .tableContainer")
        myChart = echarts.init(dom);
        var app = {};
        let xLabels = [];
        let lifeStart = 0;
        let lifeEnd = 1;
        let propStart = 0;
        let propEnd = 1;
        let bestStart = 0;
        let bestEnd = 1;

        const setRuler = (startData, endData) => {
            let xLabels = [];
            const sy = parseInt(startData.substr(0, 3))
            const sm = parseInt(startData.substr(3, 2))
            const ey = parseInt(endData.substr(0, 3))
            const em = parseInt(endData.substr(3, 2))

            let cy = sy;
            let cm = sm;
            let sw = true;
            let safe = 0; //避免無限迴圈使用
            let bk = false;

            while (sw) {
                xLabels.push(cy.toString()+"年" + (cm < 10 ? "0" + cm.toString() : cm.toString())+"月");
                if (cm >= 12) {
                    cy++;
                    cm = 1;
                } else {
                    cm++
                }
                //console.log(cy, cm)
                if (cy == ey && cm == em + 3) {
                    xLabels.push(cy.toString()+"年" + (cm < 10 ? "0" + cm.toString() : cm.toString())+"月");
                    sw = false;
                };
                safe++;
                if (safe > 24) {
                    console.log("setRuler 無限迴圈 請檢查正確數值")
                    sw = false;
                }
            }
            return xLabels;
        }

        const getRulerValue = date => {

            if (!date) {
                return 0
            }

            let _v = 1;
            for (const item of xLabels) {
                let _d = item.replace("年","")
                _d = _d.replace("月","")

                //if (date.substr(0, 5) == item) {
                if (date.substr(0, 5) == _d) {
                    break
                }
                _v++;
            }
            return _v;
        }

        const initCtData = data => {
            return new Promise((resolve, reject) => {
                let LDate = data.LBetween ? data.LBetween.split(" ~ ") : ""
                let RDate = data.RBetween ? data.RBetween.split(" ~ ") : "";
                //let SDate = data.SuggestDate.split(" ~ ")
                let SDate = data.SuggestDateHalfYear.split(" ~ ")


                if (LDate !== "" && RDate !== "") {

                    xLabels = setRuler(
                        parseInt(LDate[0]) < parseInt(RDate[0]) ? LDate[0] : RDate[0],
                        parseInt(LDate[1]) > parseInt(RDate[1]) ? LDate[1] : RDate[1]
                    )
                } else if (LDate !== "" && RDate === "") {
                    xLabels = setRuler(LDate[0], LDate[1])
                } else if (LDate === "" && RDate !== "") {
                    xLabels = setRuler(RDate[0], RDate[1])
                } else {
                    resolve(false)
                }

                lifeStart = getRulerValue(LDate[0])
                lifeEnd = getRulerValue(LDate[1])
                propStart = getRulerValue(RDate[0]);
                propEnd = getRulerValue(RDate[1]);
                bestStart = getRulerValue(SDate[0]);
                bestEnd = getRulerValue(SDate[1]);

                // myData.datasets[1].data[0].x = getRulerValue(SDate[0]);
                //myData.datasets[1].data[1].x = getRulerValue(SDate[1]);

                /* if (LDate == "" || RDate == "") {
                     resolve(false)
                 } else {
                     resolve(true)
                 }*/
            })
        }

        const init = async () => {
            //const timeline = await getTimeline();
            const timeline = data
            //console.log(timeline)
            if (timeline.LYear != null || timeline.RYear != null) {
                initCtData(timeline);
                myChart.setOption({
                    title: {
                        text: timeline.LYear ? timeline.LYear + '年度' : timeline.RYear + '年度',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        // prettier-ignore
                        data: xLabels,
                        axisLabel: {
                            textStyle: {
                                fontSize: 11,
                            }
                        }
                    },
                    yAxis: {
                        splitNumber: 2,
                        axisLabel: {
                            interval: 1,
                            fontSize: 14,
                            formatter: (index) => {
                                return ['', '壽險', '產險'][index]
                            }
                        }
                    },
                    series: [{
                        name: '壽險',
                        type: 'line',
                        data: [{
                                "value": [lifeStart, 2]
                            },
                            {
                                "value": [lifeEnd, 2]
                            },
                        ]
                    }, {
                        name: '產險',
                        type: 'line',
                        data: [{
                                "value": [propStart, 1]
                            },
                            {
                                "value": [propEnd, 1]
                            },
                        ]
                    }, {
                        name: '現在所在區間',
                        // prettier-ignore
                        type: 'line',
                        markPoint: {
                            symbol: 'triangle',
                            data: [{
                                name: '現在區間',
                                value: "現在區間",
                                xAxis: getRulerValue((d.getYear() - 11).toString() + d.getMonth().toString()),
                                yAxis: 0
                            }],
                            symbolSize: 10,
                            symbolOffset: [0, 30],
                            label: {
                                color: "#000",
                                fontSize: 24,
                                position: 'bottom'
                            }

                        },

                        data: [{
                                "value": [getRulerValue((d.getYear() - 11).toString() + d.getMonth().toString()), 0],
                                "name": "wade",

                            },
                            {
                                "value": [getRulerValue((d.getYear() - 11).toString() + d.getMonth().toString()), 2],
                                "name": "wade"
                            },
                        ],
                        smooth: true,
                        stack: 'a',
                        symbol: 'circle',
                        symbolSize: 5,
                        sampling: 'average',
                        itemStyle: {
                            color: '#F2597F',
                        },
                        markArea: {
                            label: {
                                fontSize: 16,
                                color: '#F30'
                            },
                            itemStyle: {
                                color: 'rgba(255, 173, 177, 0.4)'
                            },
                            data: [
                                [{
                                    name: '最佳上課區間',
                                    xAxis: bestStart
                                }, {
                                    xAxis: bestEnd
                                }]
                            ]
                        }
                    }]
                });

            }
        }

        window.addEventListener('resize', function () {
            if (myChart != null && myChart != undefined) {
                myChart.resize();
            }
        });

        init().then(res => {
            resolve(myChart)
        })
    })
}

export const resizeChart =()=>{
    if(myChart){
        myChart.resize()
    }
}